import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import _ from "underscore";
import axios from "axios";

class UnitService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    getUserGlobalUnit() {
        return Vue.axios.get(`${API_HOST}/api/UserGlobalUnit`, {
            headers: {},
            params: {},
            cancelToken: this.cancelTokenSource.token,
        })
    }
    getUnits({inn, limit, skip}) {
        return Vue.axios.get(`${API_HOST}/api/Unit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                limit: limit,
                skip: skip,
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getUnitUser({inn}) {
        return Vue.axios.get(`${API_HOST}/api/unitUser`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getUserUnits({inn}) {
        return Vue.axios.get(`${API_HOST}/api/UserUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                inn: typeof (inn) === 'string' ? inn : null
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    checkUnit(unit) {
        return Vue.axios.get(`${API_HOST}/api/CheckUnit`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                name: unit
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    addUnit({unitName, organizationInn , isHead, address, region, contractSum, sumForMail, sumForOverPaged, contractNumber, contractDateFrom, contractDateTo, isActive}) {
        return Vue.axios.post(`${API_HOST}/api/Unit`, {
            Name: unitName,
            OrganizationInn: organizationInn,
            IsHead: isHead,
            Address: address,
            contractSum: contractSum,
            sumForMail: sumForMail,
            sumForOverPaged: sumForOverPaged,
            contractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            isActive: isActive,
            Regions: _.map(region, r => {
                return r.id
            })
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editUnit({id, unitName, organizationInn, isHead, address, region, contractSum, sumForMail, sumForOverPaged, contractNumber, contractDateFrom, contractDateTo, isActive}) {
        return Vue.axios.put(`${API_HOST}/api/Unit`, {
            Name: unitName,
            OrganizationInn: organizationInn,
            IsHead: isHead,
            Address: address,
            contractSum: contractSum,
            sumForMail: sumForMail,
            sumForOverPaged: sumForOverPaged,
            contractNumber: contractNumber,
            ContractDateFrom: contractDateFrom ? contractDateFrom.format("DD.MM.YYYY") : null,
            ContractDateTo: contractDateTo ? contractDateTo.format("DD.MM.YYYY") : null,
            isActive: isActive,
            Regions: _.map(region, r => {
                return r.id
            })
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id
            }
        })
    }
}

export default new UnitService()
